import ComponentView from '../../dom_components/view/ComponentView';
import ConditionalComponent from '../model/conditional_variables/ConditionalComponent';

export default class ConditionalComponentView extends ComponentView<ConditionalComponent> {}
